import { MomentOwner } from '@/services/MomentsService/types'

export const getDedupedOwners = (
  owners?: MomentOwner[] | null,
  actors?: MomentOwner[] | null,
  userId?: string | null,
): MomentOwner[] => {
  const actorIds = actors?.map((actor) => actor?.id) || []

  const filteredOwners = owners?.filter((owner) => owner?.id && !actorIds.includes(owner.id) && owner.id !== userId)

  return filteredOwners || []
}

export function sortOwners(owners?: MomentOwner[] | null): MomentOwner[] {
  if (!owners) return []

  const hasStory = (x: MomentOwner) => Boolean(x?.story?.videoUri || x?.story?.text)

  const sorted = owners.sort((a, b) => {
    if (hasStory(a) && hasStory(b)) return 0
    if (hasStory(a) && !hasStory(b)) return -1
    if (!hasStory(a) && hasStory(b)) return 1

    return 0
  })

  return sorted
}
